import { useCallback } from 'react';
import { ButtonItem, ButtonsWrapper } from './TextButtons.styles';

interface ButtonsProps {
  value?: string;
  index: number;
  values: string[];
  selectOption: (value: string, index: number) => void;
}

export const ButtonsVariants = ({ value, index, values, selectOption }: ButtonsProps) => {
  const onClick = useCallback(
    (newValue: string) => {
      selectOption?.(newValue, index);
    },
    [index, selectOption]
  );

  return (
    <ButtonsWrapper className="product-variants-buttons">
      {values?.map((item: string) => (
        <ButtonItem key={item} active={item === value} onClick={() => onClick(item)}>
          {item}
        </ButtonItem>
      ))}
    </ButtonsWrapper>
  );
};
